const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_CLIENTS':
      return action.clients;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/clients.js